import { render } from "./loginRegisterLayout.vue?vue&type=template&id=80453812&scoped=true"
import script from "./loginRegisterLayout.vue?vue&type=script&lang=js"
export * from "./loginRegisterLayout.vue?vue&type=script&lang=js"

import "./loginRegisterLayout.vue?vue&type=style&index=0&id=80453812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80453812"]])

export default __exports__